module.exports = __webpack_public_path__ + "static/media/nav-arrow-gray-manatee.75082e8d.svg";